import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Row from '../../../bootstrap/component/Row'
import Column from '../../../bootstrap/component/Column'
import { Bar } from 'react-chartjs-2'
import taskListColumnList from '../../../process/component/task-list/tasklist-column-list'
import Table from '../../../form/component/Table'
import { renderStateName } from '../../../process/util/names'

const COLOR_LIST = [
    'rgb(0,145,231)',
    'rgb(255,193,44)',
    'rgb(255,138,0)',
    'rgb(255,63,107)',
    'rgb(18,178,178)',
    'rgb(133,70,255)',
    'rgb(186,188,193)',
    'rgb(0,145,231)',
    'rgb(255,193,44)',
    'rgb(255,138,0)',
    'rgb(255,63,107)',
    'rgb(18,178,178)',
    'rgb(133,70,255)',
    'rgb(186,188,193)',
]


const compileBarData = (taskByDueDateList) => {
    return {
        labels: taskByDueDateList.map(entry => {
            return entry.weekDiff
        }),
        datasets: [{
            data: taskByDueDateList.map(entry => {
                return entry.count
            }),
            backgroundColor: COLOR_LIST,
            hoverBackgroundColor: COLOR_LIST,
        }],
    }
}

const TaskList = ({ taskList, changeTaskTableSetting, taskTableSetting, navigateToTaskDetail }) => {
    if (!taskList) {
        return null
    }
    return (
        <ContentBox title="Tasklist">
            <Row>
                <Column size={12}>
                    <Table
                        rowsPerPage={0}
                        columnList={taskListColumnList(true, false)}
                        rowList={taskList}
                        changeTableSetting={changeTaskTableSetting}
                        tableSetting={taskTableSetting}
                        idProperty="id"
                        onRowClick={(task) => {
                            navigateToTaskDetail(task.id)
                        }}
                    />
                </Column>
            </Row>
        </ContentBox>
    )
}


const TaskByDueDate = ({ taskByDueDateList, currentTaskName, findTaskByWeekDiff, taskList, changeTaskTableSetting, taskTableSetting, navigateToTaskDetail }) => {
    if (!taskByDueDateList || !taskByDueDateList.length) {
        return null
    }
    const title = 'Task Due : ' + renderStateName(currentTaskName)

    return (
        <div>
            <ContentBox title={title}>
                <Row>
                    <Column size={12}>
                        <h3>Calendar Weeks</h3>
                        <Bar
                            getElementAtEvent={dataset => {
                                findTaskByWeekDiff(dataset[0]._index)
                            }}
                            options={{
                                legend: {
                                    display: false,
                                },
                                scales: {
                                    yAxes: [{
                                        ticks: {
                                            beginAtZero: true,
                                        },
                                    }],
                                },
                            }}
                            data={compileBarData(taskByDueDateList)}
                        />
                    </Column>
                </Row>
            </ContentBox>
            <TaskList
                taskList={taskList}
                changeTaskTableSetting={changeTaskTableSetting}
                navigateToTaskDetail={navigateToTaskDetail}
                taskTableSetting={taskTableSetting}/>
        </div>)
}

TaskByDueDate.propTypes = {
    taskByDueDateList: PropTypes.array,
    findTaskByWeekDiff: PropTypes.func.isRequired,
    taskList: PropTypes.array,

}

export default TaskByDueDate



// WEBPACK FOOTER //
// ./src/modules/analytics/component/state-responsible/TaskByDueDate.js